import React from 'react';
import { SITE } from '../constants/site';

function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-slate-950 text-slate-300">
      <div className="mx-auto max-w-7xl px-6 py-12 md:py-14">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
          <div>
            <p className="font-display text-lg font-semibold text-white">{SITE.businessName}</p>
            <p className="mt-2 max-w-sm text-sm leading-relaxed text-slate-400">
              Designer eyewear, contact lenses, and eye exams — personalized care on Willis Ave in Albertson.
            </p>
          </div>
          <nav aria-label="Footer">
            <ul className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:gap-x-8 sm:gap-y-3">
              <li>
                <a
                  href="#services"
                  className="text-sm text-slate-400 underline-offset-4 hover:text-white hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-optical-400 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950"
                >
                  Services
                </a>
              </li>
              <li>
                <a
                  href="#store-info"
                  className="text-sm text-slate-400 underline-offset-4 hover:text-white hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-optical-400 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950"
                >
                  Visit us
                </a>
              </li>
              <li>
                <a
                  href="#contact-us"
                  className="text-sm text-slate-400 underline-offset-4 hover:text-white hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-optical-400 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950"
                >
                  Contact
                </a>
              </li>
              <li>
                <a
                  href="#legal-privacy"
                  className="text-sm text-slate-400 underline-offset-4 hover:text-white hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-optical-400 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="#legal-terms"
                  className="text-sm text-slate-400 underline-offset-4 hover:text-white hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-optical-400 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950"
                >
                  Terms of Service
                </a>
              </li>
            </ul>
          </nav>
        </div>

        <div id="legal-privacy" className="sr-only" tabIndex={-1}>
          Privacy policy: contact us for details.
        </div>
        <div id="legal-terms" className="sr-only" tabIndex={-1}>
          Terms of service: contact us for details.
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-slate-800 pt-8 text-center text-sm text-slate-500 md:flex-row md:items-center md:justify-between md:text-left">
          <p>© {new Date().getFullYear()} {SITE.businessName}. All rights reserved.</p>
          <p>
            Powered by{' '}
            <a
              href="https://ax2tech.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-optical-400 underline-offset-4 hover:text-optical-300 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-optical-400 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950"
            >
              Ax2 Technologies
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
